export default "__VITE_ASSET__COFlUisO__"